import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  flag: {
    base: {
      display: 'flex',
      alignItems: 'center',
    },
    reversed: {
      flexDirection: 'row-reverse',
    },
    'gutter-size-small': {
      margin: `0 -${theme.settings.spacing.xSmall} 0`,
    },
    'gutter-size-medium': {
      margin: `0 -${theme.settings.spacing.small} 0`,
    },
    'gutter-size-large': {
      margin: `0 -${theme.settings.spacing.medium} 0`,
    },
  },
  img: {
    base: {
      position: 'relative',
    },
    'gutter-size-small': {
      margin: `0 ${theme.settings.spacing.xSmall} 0`,
    },
    'gutter-size-medium': {
      margin: `0 ${theme.settings.spacing.small} 0`,
    },
    'gutter-size-large': {
      margin: `0 ${theme.settings.spacing.medium} 0`,
    },
  },
  body: {
    base: {
      flex: '1',
      flexShrink: 1,
      minWidth: 0,
    },
    'gutter-size-small': {
      margin: `0 ${theme.settings.spacing.xSmall} 0`,
    },
    'gutter-size-medium': {
      margin: `0 ${theme.settings.spacing.small} 0`,
    },
    'gutter-size-large': {
      margin: `0 ${theme.settings.spacing.medium} 0`,
    },
  },
})
